'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAspectRatio = function ActionAspectRatio(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
  );
};
ActionAspectRatio = (0, _pure2.default)(ActionAspectRatio);
ActionAspectRatio.displayName = 'ActionAspectRatio';
ActionAspectRatio.muiName = 'SvgIcon';

exports.default = ActionAspectRatio;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/aspect-ratio.js
// module id = 2473
// module chunks = 0